import {
  endOfMonth,
  endOfWeek,
  endOfYear,
  startOfMonth,
  startOfWeek,
  startOfYear,
  subDays,
} from "date-fns";

export { default as auth_bg_img } from "@/assets/images/auth-bg.png";
export { default as bell_icon } from "@/assets/images/bell-nav.png";
export { default as checkbox_checked_icon } from "@/assets/images/checkbox-checked.png";
export { default as checkbox_icon } from "@/assets/images/checkbox.png";
export { default as delete_img } from "@/assets/svgs/garbage.svg";
export { default as delete_icon } from "@/assets/svgs/garbage.svg";
export { default as download_img } from "@/assets/images/download.svg";
export { default as dropzon_upload_img } from "@/assets/images/dropzone-upload-icon.svg";
export { default as eye_off_icon } from "@/assets/images/eye-off.png";
export { default as forgot_password_icon } from "@/assets/images/forgot-password-icon.png";
export { default as image_upload_svg } from "@/assets/images/image-upload.svg";
export { default as info_icon } from "@/assets/svgs/info.svg";
export { default as link_img } from "@/assets/images/link.svg";
export { default as logo } from "@/assets/svgs/Logo.svg";
export { default as app_logo_full } from "@/assets/svgs/Logo.svg";
export { default as app_logo } from "@/assets/svgs/LogoIcon.svg";
export { default as logout_red_icon } from "@/assets/images/logout-red.png";
export { default as success_icon } from "@/assets/images/password-success-icon.png";
export { default as pdf_file_img } from "@/assets/images/pdf-file-icon.svg";
export { default as search_img } from "@/assets/images/search.svg";
export { default as closed_arrow } from "@/assets/images/sidebar/closed-arrow.png";
export { default as help_center_icon } from "@/assets/images/sidebar/help-center.png";
export { default as logout_icon } from "@/assets/images/sidebar/logout.png";
export { default as open_arrow } from "@/assets/images/sidebar/open-arrow.png";
export { default as settings_icon } from "@/assets/images/sidebar/settings.png";
export { default as upload_img } from "@/assets/images/upload.svg";
export { default as arrow_down_icon } from "@/assets/svgs/arrow-down.svg";
export { default as black_filter_img } from "@/assets/svgs/black_filter.svg";
export { default as home_icon } from "@/assets/svgs/breadcomb-home.svg";
export { default as calendar_icon } from "@/assets/svgs/Calendar.svg";
export { default as close_x_img } from "@/assets/svgs/Close_x.svg";
export { default as coins_dollar } from "@/assets/svgs/coins_dollar.svg";
export { default as distinct_hts } from "@/assets/svgs/distinct_hts.svg";
export { default as distinct_imports } from "@/assets/svgs/distinct_imports.svg";
export { default as download_icon } from "@/assets/svgs/download-black.svg";
export { default as duties_placeholder } from "@/assets/svgs/duties_placeholder.svg";
export { default as duty_saving_placeholder } from "@/assets/svgs/duty_saving_placeholder.svg";
export { default as edit_icon } from "@/assets/svgs/edit.svg";
export { default as footer_bg_banner } from "@/assets/images/footer_bg_banner.png";
export { default as footer_rocket } from "@/assets/svgs/footer_rocket.svg";
export { default as excel_img } from "@/assets/svgs/excel_file.svg";
export { default as coins } from "@/assets/svgs/coins-01.svg";
export { default as chart_down } from "@/assets/svgs/chart-down.svg";
export { default as date_time } from "@/assets/svgs/date-time.svg";
export { default as featured_delete_icon } from "@/assets/svgs/garbage.svg";
export { default as filter_black_icon } from "@/assets/svgs/filter-black.svg";
export { default as filter_icon } from "@/assets/svgs/filter.svg";
export { default as graph_up_icon } from "@/assets/svgs/graph.svg";
export { default as imports_exports_placeholder } from "@/assets/svgs/imports_exports_placeholder.svg";
export { default as imports_placeholder } from "@/assets/svgs/imports_placeholder.svg";
export { default as list_img } from "@/assets/svgs/list.svg";
export { default as metrics_placeholder } from "@/assets/svgs/metrics_placeholder.svg";
export { default as no_data_img } from "@/assets/svgs/no-data.svg";
export { default as file_icon } from "@/assets/svgs/pdf-file.svg";
export { default as percent_circle } from "@/assets/svgs/percent_circle.svg";
export { default as plus_img } from "@/assets/svgs/Plus.svg";
export { default as admin_panel_settings_icon } from "@/assets/svgs/ShieldCheck.svg";
export { default as sort_img } from "@/assets/svgs/sort.svg";
export { default as spread_sheet_icon } from "@/assets/svgs/spread-sheet.svg";
export { default as table_sort } from "@/assets/svgs/table-sort.svg";
export { default as tariff_code_placeholder } from "@/assets/svgs/tariff_code_placeholder.svg";
export { default as view_only_user_img } from "@/assets/svgs/view_only_user.svg";
export { default as unlock_right } from "../assets/svgs/unlock_right.svg";
export { default as preview_image } from "../assets/svgs/preview-image.svg";
export { default as shield_admin_img } from "@/assets/svgs/Shield_admin.svg";
export { default as profile_preview } from "@/assets/svgs/profile-preview.svg";
export { default as contact_support } from "@/assets/svgs/contact-support.svg";
export { default as check_list } from "@/assets/svgs/check-list.svg";
export { default as inactive_step } from "@/assets/svgs/inactive-step.svg";
export { default as active_step } from "@/assets/svgs/active-step.svg";
export { default as completed_step } from "@/assets/svgs/completed-step.svg";
export { default as target_arrow } from "@/assets/svgs/target-arrow.svg";
export { default as hand_shake } from "@/assets/svgs/hand_shake.svg";
export { default as modal_close } from "@/assets/svgs/modal-close-icon.svg";
export { default as hero_showcase } from "@/assets/images/hero-showcase.png";
export { default as hero_img } from "@/assets/images/shadow_hero_updated.webp";
export { default as hero_img_mobile } from "@/assets/images/shadow_hero_mobile.avif";
export { default as stars } from "@/assets/svgs/stars.svg";
export { default as excel_file } from "@/assets/svgs/excel-file.svg";
export { default as crash_warning } from "@/assets/svgs/crash-warning.svg";
export { default as report_cross } from "@/assets/svgs/report-cross.svg";
export { default as potential_saving } from "@/assets/images/potential-saving.png";
export { default as play_book } from "@/assets/svgs/play-book.svg";
export { default as stats_analysis } from "@/assets/svgs/stats-analysis.svg";
export { default as guide } from "@/assets/svgs/guide.svg";
export { default as amazon_logo } from "@/assets/images/amazon-logo.png";
export { default as gdlsk_logo } from "@/assets/images/gdlsk-logo.png";
export { default as ey_logo } from "@/assets/images/ey-logo.png";
export { default as kpmg_logo } from "@/assets/images/kpmg-logo.png";
export { default as us_trade_logo } from "@/assets/images/us-trade-logo.png";
export { default as amazon } from "@/assets/svgs/amazon.svg";
export { default as gdlsk } from "@/assets/svgs/gdlsk.svg";
export { default as ey } from "@/assets/svgs/ey.svg";
export { default as kpmg } from "@/assets/svgs/kpmg.svg";
export { default as us_trade } from "@/assets/svgs/us_trade.svg";
export { default as rocket } from "@/assets/svgs/rocket.svg";
export { default as company_placeholder } from "@/assets/images/sidebar/partners.png";
import admin_shield from "@/assets/svgs/Shield_admin.svg";
import view_only_img from "@/assets/svgs/view_only_user.svg";
import { DocumentAccessLevel } from "@/roles";

export const PaginationConstants = {
  pageNo: 1,
  pageSize: 12,
};

export const PaginationLimitOptionsConstants = [
  { label: "Show 12", value: "12" },
  { label: "Show 20", value: "20" },
  { label: "Show 30", value: "30" },
  { label: "Show 50", value: "50" },
];

export const maxLengthsBlog = {
  title: 120,
  slug: 60,
};

export const chartColors = ["#0B494B", "#33DAE0", "#1CB4BA", "#0E6B6F", "#E3E3E8"];

export const userRightsEnums = {
  admin: "ADMIN",
  view_only: "USER",
};

export const ROW_HEIGHT = "auto"; // allow row to grow with wrapped content

export const clientInitialPermissions = {
  dashboard: {
    ANALYTICS: false,
    // Legacy keys kept for type compatibility; not used in UI
    SAVING: false,
    COMPLIANCE: false,
  },
  documents: DocumentAccessLevel.ViewOnly,
  reports: {
    SALES: false,
    PERFORMANCE: false,
    AUDIT: false,
  },
};

export const userRightOptions = [
  {
    label: "User",
    value: "USER",
    imgUrl: view_only_img,
  },
  {
    label: "Admin",
    value: "ADMIN",
    imgUrl: admin_shield,
  },
];

export const userManagementStatus = [
  { label: "Active", value: "active" },
  { label: "Restricted", value: "restricted" },
];

export const POTENTIAL_TABS = [
  {
    text: "First Sale",
    link: "first-sale",
  },
  {
    text: "Preferential Origin",
    link: "preferential-origin",
  },
  {
    text: "FTZ",
    link: "ftz",
  },
  {
    text: "301 Exclusions",
    link: "exclusions",
  },
];


export const faqData = [
  {
    question: "How and when do I get paid?",
    answer:
      "Fermentum egestas at nunc tristique. Feugiat sodales viverra odio nisi non sem mauris. Nisi at purus habitant dictum etiam mi adipiscing...",
  },
  {
    question: "Are you the merchant of record?",
    answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit...",
  },
  {
    question: "Can I sell in other countries?",
    answer:
      "Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae...",
  },
  {
    question: "What if I already have a website?",
    answer: "Pellentesque habitant morbi tristique senectus et netus...",
  },
  {
    question: "How does my email plan work?",
    answer: "Sed posuere consectetur est at lobortis...",
  },
  {
    question: "Can I send emails?",
    answer: "Cras mattis consectetur purus sit amet fermentum...",
  },
  {
    question: "Marking an Invoice Paid Out of Band",
    answer: "Vivamus sagittis lacus vel augue laoreet rutrum faucibus...",
  },
];

export const PRESET_RANGES = [
  { label: "Today", range: { startDate: new Date(), endDate: new Date() } },
  {
    label: "Yesterday",
    range: {
      startDate: subDays(new Date(), 1),
      endDate: subDays(new Date(), 1),
    },
  },
  {
    label: "This Week",
    range: {
      startDate: subDays(new Date(), 6),
      endDate: new Date(),
    },
  },
  {
    label: "Last Week",
    range: {
      startDate: startOfWeek(subDays(new Date(), 7)),
      endDate: endOfWeek(subDays(new Date(), 7)),
    },
  },
  {
    label: "This Month",
    range: {
      startDate: startOfMonth(new Date()),
      endDate: new Date(),
    },
  },
  {
    label: "Last Month",
    range: {
      startDate: startOfMonth(subDays(new Date(), 30)),
      endDate: endOfMonth(subDays(new Date(), 30)),
    },
  },
  {
    label: "This Year",
    range: {
      startDate: startOfYear(new Date()),
      endDate: new Date(),
    },
  },
  {
    label: "Last Year",
    range: {
      startDate: startOfYear(subDays(new Date(), 365)),
      endDate: endOfYear(subDays(new Date(), 365)),
    },
  },
  {
    label: "Last 30 Days",
    range: { startDate: subDays(new Date(), 30), endDate: new Date() },
  },
  {
    label: "All Time",
    range: { startDate: new Date(2000, 0, 1), endDate: new Date() },
    isAllTime: true,
  },
];

export const DUTY_ATTRIBUTES: IDutyAttribute[] = [
  { label: "MTB", value: "mtb" },
  { label: "301", value: "sec301" },
  { label: "Exclusions", value: "exclusions" },
];

export const VENDOS_TOTAL_FIELDS: VendorSection[] = [
  { type: "total", name: "Total" },
  { type: "field", fieldName: "customsValue", symbol: "$" },
  { type: "field", fieldName: "customsDuty", symbol: "$" },
  { type: "field", fieldName: "percentCustomValue", symbol: "%" },
];

export const PROGRAMS_TOTAL_FIELDS: VendorSection[] = [
  { type: "total", name: "Total" },
  { type: "field", fieldName: "totalSaving", symbol: "" },
];

export const TARIFF_CODES_TOTAL_FIELDS: VendorSection[] = [
  { type: "total", name: "Total" },
  { type: "field", fieldName: "tariffValue", symbol: "$" },
  { type: "field", fieldName: "tariffDuty", symbol: "$" },
  { type: "field", fieldName: "effectiveDutyRate", symbol: "" },
  { type: "field", fieldName: "percentOfTotal", symbol: "" },
];

export const CURRENCIES = [
  {
    value: "USD",
    label: "USD",
    symbol: "$",
  },
  {
    value: "MXN",
    label: "MXN",
    symbol: "$",
  },
  {
    value: "CAD",
    label: "CAD",
    symbol: "$",
  },
  {
    value: "GBP",
    label: "GBP",
    symbol: "£",
  },
  {
    value: "EUR",
    label: "EUR",
    symbol: "€",
  },
  {
    value: "CNY",
    label: "CNY",
    symbol: "¥",
  },
];

export * from "./countries";
export * from "./post-import";
